<div class="dashboard-top-section d-flex align-items-center justify-content-between">
  <div class="d-flex align-items-center gap-2">
    <button class="back-button" [title]="'serviceLibrary.back' | transloco" (click)="onBackButtonClick()">
      <span>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.9999 11H6.41394L11.7069 5.70697L10.2929 4.29297L2.58594 12L10.2929 19.707L11.7069 18.293L6.41394 13H20.9999V11Z" fill="#9FA1A4"/>
        </svg>
      </span>
    </button>
    <h1> {{ schedule.name }} </h1>
  </div>

  <div class="d-flex align-items-center gap-2">
    @if (schedule.serviceScheduleTypeId !== ScheduleType.Custom) {
      <span ngbDropdown class="service-library-filters" [autoClose]="true">
        <button type="button" class="btn service-library-filters form-control dropdown-toggle search-input" id="modelFilterDropdown"
          [disabled]="isLoadingModels" ngbDropdownToggle>
          <div class="d-flex flex-row justify-content-between dropdown-inner">
            <span class="align-middle filter-label" [class.is-selected]="!!selectedModel">{{ isLoadingModels ? ('serviceLibrary.filterPage.loading' | transloco) : modelLabel }}</span>
            <i class="ph ph-caret-down lh-base"></i>
          </div>
        </button>
        <div ngbDropdownMenu aria-labelledby="modelFilterDropdown">
          <div class="d-flex flex-column">
            @for (model of models; track model.id) {
              <button class="btn btn-outline" ngbDropdownItem (click)="onSelectModel(model)">{{ model.name }}</button>
            }
          </div>
        </div>
      </span>
      <span ngbDropdown class="service-library-filters" [autoClose]="true">
        <button type="button" class="btn service-library-filters form-control dropdown-toggle search-input" id="yearFilterDropdown" 
          [disabled]="yearDisabled || isLoadingYears" [attr.aria-disabled]="yearDisabled" ngbDropdownToggle>
          <div class="d-flex flex-row justify-content-between dropdown-inner">
            <span class="align-middle filter-label" [class.is-selected]="selectedYear != null">{{ isLoadingYears ? ('serviceLibrary.filterPage.loading' | transloco) : yearLabel  }}</span>
            <i class="ph ph-caret-down lh-base"></i>
          </div>
        </button>
        <div ngbDropdownMenu aria-labelledby="yearFilterDropdown">
          <div class="d-flex flex-column">
            @for (year of years; track year) {
              <button class="btn btn-outline" ngbDropdownItem (click)="onSelectYear(year)">{{ year }}</button>
            }
          </div>
        </div>
      </span>
    }
    <span ngbDropdown class="service-library-filters service-type" [autoClose]="true">
      <button type="button" class="btn service-library-filters form-control dropdown-toggle search-input"  id="serviceTypeFilterDropdown"
        [disabled]="serviceTypeDisabled || isLoadingServiceTypes" [attr.aria-disabled]="serviceTypeDisabled" ngbDropdownToggle>
        <div class="d-flex flex-row justify-content-between dropdown-inner">
          <span class="align-middle filter-label" [class.is-selected]="selectedServiceType != null">{{ isLoadingServiceTypes ? ('serviceLibrary.filterPage.loading' | transloco) : serviceTypeLabel }}</span>
          <i class="ph ph-caret-down lh-base"></i>
        </div>
      </button>
      <div ngbDropdownMenu aria-labelledby="serviceTypeFilterDropdown">
        <div class="d-flex flex-column drop-down">
          @for (serviceType of serviceTypeOptions; track serviceType.value) {
            <button class="btn btn-outline" ngbDropdownItem (click)="onSelectServiceType(serviceType.value)">{{ serviceType.label | transloco }}</button>
          }
        </div>
      </div>
    </span>
  </div>
</div>

<div class="bottom-grid-section">
  <div class="bottom-grid-sec-left">
    <div class="service-library-overlay">
      @if (schedule.imageUrl) {
        <img [src]="schedule.imageUrl" [attr.alt]="'serviceLibrary.assetPhotoAlt' | transloco" class="overlay-image" />
      }
      <div class="overlay-content">
        <div class="empty-filter-state">
          <div class="empty-filter-state-icon">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path opacity="0.2" d="M56 32C56 36.7468 54.5924 41.3869 51.9553 45.3337C49.3181 49.2805 45.5698 52.3566 41.1844 54.1731C36.799 55.9896 31.9734 56.4649 27.3178 55.5388C22.6623 54.6128 18.3859 52.327 15.0294 48.9706C11.673 45.6141 9.38721 41.3377 8.46116 36.6822C7.53512 32.0266 8.0104 27.201 9.8269 22.8156C11.6434 18.4302 14.7195 14.6819 18.6663 12.0447C22.6131 9.40758 27.2533 8 32 8C38.3652 8 44.4697 10.5286 48.9706 15.0294C53.4714 19.5303 56 25.6348 56 32Z" fill="#9FA1A4"/>
              <path d="M36 44C36 44.5304 35.7893 45.0391 35.4142 45.4142C35.0392 45.7893 34.5304 46 34 46C32.9391 46 31.9217 45.5786 31.1716 44.8284C30.4214 44.0783 30 43.0609 30 42V32C29.4696 32 28.9609 31.7893 28.5858 31.4142C28.2107 31.0391 28 30.5304 28 30C28 29.4696 28.2107 28.9609 28.5858 28.5858C28.9609 28.2107 29.4696 28 30 28C31.0609 28 32.0783 28.4214 32.8284 29.1716C33.5786 29.9217 34 30.9391 34 32V42C34.5304 42 35.0392 42.2107 35.4142 42.5858C35.7893 42.9609 36 43.4696 36 44ZM58 32C58 37.1423 56.4751 42.1691 53.6182 46.4448C50.7613 50.7205 46.7007 54.053 41.9498 56.0209C37.1989 57.9887 31.9712 58.5036 26.9277 57.5004C21.8842 56.4972 17.2514 54.0209 13.6152 50.3848C9.97907 46.7486 7.50281 42.1159 6.49959 37.0723C5.49638 32.0288 6.01127 26.8011 7.97914 22.0502C9.94702 17.2994 13.2795 13.2387 17.5552 10.3818C21.8309 7.52487 26.8577 6 32 6C38.8934 6.00728 45.5024 8.74889 50.3767 13.6233C55.2511 18.4976 57.9927 25.1066 58 32ZM54 32C54 27.6488 52.7097 23.3953 50.2923 19.7775C47.875 16.1596 44.439 13.3398 40.419 11.6747C36.3991 10.0095 31.9756 9.57385 27.708 10.4227C23.4404 11.2716 19.5204 13.3669 16.4437 16.4437C13.3669 19.5204 11.2716 23.4404 10.4227 27.708C9.57386 31.9756 10.0095 36.3991 11.6747 40.419C13.3398 44.439 16.1596 47.8749 19.7775 50.2923C23.3953 52.7097 27.6488 54 32 54C37.8327 53.9934 43.4247 51.6734 47.5491 47.549C51.6734 43.4247 53.9934 37.8327 54 32ZM31 24C31.5934 24 32.1734 23.8241 32.6667 23.4944C33.1601 23.1648 33.5446 22.6962 33.7716 22.1481C33.9987 21.5999 34.0581 20.9967 33.9424 20.4147C33.8266 19.8328 33.5409 19.2982 33.1213 18.8787C32.7018 18.4591 32.1672 18.1734 31.5853 18.0576C31.0033 17.9419 30.4001 18.0013 29.852 18.2284C29.3038 18.4554 28.8352 18.8399 28.5056 19.3333C28.176 19.8266 28 20.4067 28 21C28 21.7956 28.3161 22.5587 28.8787 23.1213C29.4413 23.6839 30.2044 24 31 24Z" fill="#9FA1A4"/>
            </svg>              
          </div>
          <div class="empty-filter-state-title">
            <span class="empty-filter-state-title-text" [innerHTML]="'serviceLibrary.filterPage.emptyTitle' | transloco"></span>
          </div>
          <div class="empty-filter-state-description">
            <p>{{ 'serviceLibrary.filterPage.emptyDescription' | transloco }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>